import type { ColumnDef } from './types.js';

/** Captures the accessor's return type as V so formatter/render receive it typed. */
export const defineCol = <T, V extends string | number | null>(
    def: ColumnDef<T, V>,
): ColumnDef<T> => def;
